import React from 'react';
import { VandaagCard, VannachtCard, KoffieCard, WeerCard, RouteCard, LisaCard } from './cards/InfoCards';
import { DeurCard, VerwarmingCard, LichtCard, KlimaatCard, GeweigerdCard, MailDraftCard } from './cards/HomeCards';
import type { AgentId, SoundId } from '../../types/anna';
import type { StageCard } from '../../types/stage';
interface StageCardViewProps {
  card: StageCard;
  onRemove: (uid: string) => void;
  onApproved: (agent: AgentId) => void;
  onSound: (id: SoundId) => void;
}
export function StageCardView({
  card,
  onRemove,
  onApproved,
  onSound
}: StageCardViewProps) {
  switch (card.kind) {
    case 'vandaag':
      return <VandaagCard data-id="element-1538" data-mp="tf1l66b3yju5" />;
    case 'vannacht':
      return <VannachtCard data-id="element-1539" data-mp="og86iak34mse" />;
    case 'koffie':
      return <KoffieCard data-id="element-1540" data-mp="ohj8c4tyzkgv" />;
    case 'weer':
      return <WeerCard data-id="element-1541" data-mp="2v6xxvj90hzqi" />;
    case 'route':
      return <RouteCard data-id="element-1542" data-mp="2v7pqcl7bbhck" />;
    case 'lisa':
      return <LisaCard data-id="element-1543" data-mp="2q84itme2u0o8" />;
    case 'deur':
      return <DeurCard data-id="element-1544" data-mp="2q9egwbkxj8uv" />;
    case 'verwarming':
      return <VerwarmingCard onDone={() => onRemove(card.uid)} onSound={() => onSound('klaar')} data-id="element-1545" data-mp="2aiojiu48x3ke" />;
    case 'licht':
      return <LichtCard room={card.payload?.room} data-id="element-1546" data-mp="2fh868wqnyjdt" />;
    case 'klimaat':
      return <KlimaatCard room={card.payload?.room} data-id="element-1547" data-mp="2ffew37gudh12" />;
    case 'geweigerd':
      return <GeweigerdCard subject={card.payload?.subject} data-id="element-1548" data-mp="2kfjfb594wpuz" />;
    case 'mailDraft':
      return <MailDraftCard onApproved={() => {
        onApproved('mail');
        window.setTimeout(() => onRemove(card.uid), 1400);
      }} data-id="element-1549" data-mp="2p9488ivvetnb" />;
    default:
      return null;
  }
}